module.exports = "/static/assets/89b23cdaf4cd793344e503007bd3b405.gif";